import React, { useState } from "react";
import Modal from "../../components/modal/Modal";
import ArticleForm from "./ArticleForm";
import searchIcon from "../../assets/icons/search.svg";
import Button from "../../components/UI/button/GgButton";
import { AddIcon } from "../../assets/icons";
import { useModal } from "../../customHooks/useModal";

interface IHeader {
  searchItems: (value: string) => void;
  page?: number;
  actionData?: any;
}

const Header = ({ searchItems, page, actionData }: IHeader) => {
  const modal = useModal();
  return (
    <div className="articles-header">
      <div className="title">Editing articles</div>
      <div className="controls">
        <label htmlFor="search">
          <span className="input-container">
            <span className="icon">
              <img src={searchIcon} alt="search" />
            </span>
            <input
              type="text"
              id="search"
              className="input"
              onChange={(e) => searchItems(e.target.value)}
              placeholder="Search for articles"
            />
          </span>
        </label>
        {actionData?.add ? (  
          <Button
            icon={{ leftIcon: <AddIcon className="icon" /> }}
            stylesType="round"
            onPress={modal.openModal}
          />
        ): "" }
      </div>
      <Modal
        show={modal.showModal}
        onClose={modal.setModalShow}
        title="Add post"
      >
        <ArticleForm page={page} onClose={modal.closeModal} actionData={actionData} />
      </Modal>
    </div>
  );
};

export default Header;
